module.exports = __webpack_public_path__ + "static/media/agenda.c1532090.pdf";